export class FilterUIManager {
  constructor(container) {
    this.container = container;
  }

  toggleMultiSelect(toggle) {
    const multiSelect = toggle.parentElement;
    const options = multiSelect.querySelector('.multi-select-options');
    const isCurrentlyOpen = multiSelect.classList.contains('open');

    // Close all multi-selects first
    this.closeAllMultiSelects();

    // If it wasn't open, open this one
    if (!isCurrentlyOpen) {
      multiSelect.classList.add('open');
      toggle.classList.add('active');
      options.classList.add('visible');

      // Calculate position
      const rect = multiSelect.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (spaceBelow < 200 && spaceAbove > spaceBelow) {
        options.style.bottom = '100%';
        options.style.top = 'auto';
      } else {
        options.style.top = '100%';
        options.style.bottom = 'auto';
      }
    }
  }

  closeAllMultiSelects() {
    this.container.querySelectorAll('.custom-multi-select').forEach(select => {
      select.classList.remove('open');
      const toggle = select.querySelector('.multi-select-toggle');
      const options = select.querySelector('.multi-select-options');
      if (toggle) toggle.classList.remove('active');
      if (options) options.classList.remove('visible');
    });
  }
}